import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useEffect, useState } from 'react';

export interface IPermissionControlParent {
  columnName: string;
  category: string;
  checked: boolean;
  indeterminate: boolean;
  handleChangeEventParentRow: (
    event: React.ChangeEvent<HTMLInputElement>,
    column: string,
    category: string
  ) => void;
}

const PermissionControlParent = ({
  columnName,
  category,
  checked,
  indeterminate,
  handleChangeEventParentRow,
}: IPermissionControlParent) => {
  const [isChecked, setChecked] = useState(checked);
  const [isIndeterminate, setIndeterminate] = useState(indeterminate);
  useEffect(() => {
    setIndeterminate(indeterminate);
    setChecked(checked);
  }, [checked, indeterminate]);
  return (
    <FormControlLabel
      label=""
      control={
        <Checkbox
          checked={isChecked}
          indeterminate={isIndeterminate}
          onChange={(event) => {
            handleChangeEventParentRow(event, columnName, category);
          }}
        />
      }
    />
  );
};

export default PermissionControlParent;
